import { useQuery } from 'react-query';

import { getHub } from 'api/traps/Hubs/getHub';

export const useGetHub = (hubId: number) => {
  const { data, refetch, isLoading } = useQuery('getHub', () => getHub(hubId), {
    enabled: hubId > 0,
    refetchOnWindowFocus: false,
  });

  return { hubInfo: data, refetch, isLoading };
};

export default useGetHub;
